/* eslint-disable import/no-extraneous-dependencies */
import { initReactI18next } from 'react-i18next'
import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { ENConfig, PLConfig } from '@assets/locales'
import * as config from './config'

export const resources = {
  en: ENConfig,
  pl: PLConfig
}

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: config.fallbackLanguage,
    // Without it a browser in, say, German resolves to `de`, which has no
    // translations and matches no entry in the language picker.
    supportedLngs: config.supportedLanguages,
    ns: config.namespaces,
    defaultNS: config.defaultNameSpace,
    debug: true,
    resources,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      convertDetectedLanguage: lng => lng?.split('-')[0]
    }
  })
  .then(() => {
    const storedLng = localStorage.getItem('i18nextLng')
    if (!storedLng && i18next.language) {
      localStorage.setItem('i18nextLng', i18next.language)
    }
  })
